import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { LoadingIndicator } from '../../../../components/loading-indicator.component';
import { ApiErrorComponent } from '../../../../components/api-error.component';
import { useDeleteData } from '../../../../hooks/useDeleteData';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { useEffect, useState } from 'react';
import { useAuthorize } from '../../../../hooks/use-authorize';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface DeleteMapItemComponent {
  contactID: number;
  removeData: any;
  onClosed: () => void;
}
export const DeleteMapItemComponent = ({ contactID, removeData, onClosed }: DeleteMapItemComponent) => {
  const [deleteData, setDeleteData] = useState<any>();

  const {
    data: removeMappedData,
    error,
    isError,
    isLoading: isMapppedDataLoading,
    mutateAsync: mutateMappedData,
  } = useDeleteData(
    contactApiKeyStore.deleteContactMaping(
      contactID,
      0,
      deleteData?.type == 'office' ? deleteData.id : 0,
      deleteData?.type == 'project' ? deleteData.id : 0,
      deleteData?.type == 'unit' ? deleteData.id : 0,
      true
    ),
    () => contactApiKeyStore.getMappingContacts(contactID)
  );

  const handleRemoveMappedData = async () => {
    await mutateMappedData();
    onClosed();
  };

  useEffect(() => {
    if (removeData) setDeleteData(removeData);
  }, [removeData]);

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'sm'}
    // onClose={onClosed}
    >
      <DialogTitle id="scroll-dialog-title" style={{ color: '#ff8a8a' }}>
        Warning
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 15,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <div>
          {removeData.type == 'office' && (
            <div style={{ padding: '25px 50px', textAlign: 'center' }}>
              <p style={{ paddingBottom: 10 }}>
                Removing the contact from <b>{removeData.name}</b> office will also remove the contact from all the
                associated projects and units.
              </p>
              <div style={{ paddingBottom: 10 }}>Are you sure you want to proceed?</div>
              <div>
                <b>Project Mapped:</b> {removeData.projectCount}
              </div>
              <div>
                <b>Unit Mapped:</b> {removeData.unitCount}
              </div>
              <LoadingIndicator isLoading={isMapppedDataLoading} />
              <ApiErrorComponent isError={isError} errorRespnse={error} />
            </div>
          )}
          {removeData.type == 'project' && (
            <div style={{ padding: '25px 50px', textAlign: 'center' }}>
              <p style={{ paddingBottom: 10 }}>
                Removing the contact from <b>{removeData.name}</b> project will also remove the contact from all the
                associated units.
              </p>
              <div style={{ paddingBottom: 10 }}>Are you sure you want to proceed?</div>
              <div>
                <b>Unit Mapped:</b> {removeData.unitCount}
              </div>
              <LoadingIndicator isLoading={isMapppedDataLoading} />
              <ApiErrorComponent isError={isError} errorRespnse={error} />
            </div>
          )}
          {removeData.type == 'unit' && (
            <div style={{ padding: '25px 50px', textAlign: 'center' }}>
              <p style={{ paddingBottom: 10 }}>
                Removing the contact from <b>{removeData.name}</b> unit.
              </p>
              <div>Are you sure you want to proceed?</div>
              <LoadingIndicator isLoading={isMapppedDataLoading} />
              <ApiErrorComponent isError={isError} errorRespnse={error} />
            </div>
          )}
        </div>
      </DialogContent>
      <div style={{ padding: '5px', paddingLeft: '16px', paddingRight: '16px' }}>
        <DialogActions className="spaceBetween">
          <Button variant="outlined" style={{ width: '130px' }} onClick={onClosed}>
            Cancel
          </Button>
          <Button
            type="button"
            variant="contained"
            disabled={isReadOnlyPermission}
            onClick={handleRemoveMappedData}
            style={{ width: '100px', backgroundColor: !isReadOnlyPermission?'#ff8a8a':'#d7dbdd' }}
          >
            OK
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
